<template>
    <va-edit-layout>
        <FinancialOrderDirectPayment-form
            :id="id"
            :title="title"
            :item="item"
        ></FinancialOrderDirectPayment-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
